import React, { useEffect, useState } from "react";
import { fetchIpaLessons, deleteIpaLesson } from "./adminIpaService";
import AdminIpaLessonForm from "./AdminIpaLessonForm";

const AdminIpaLessonPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [search, setSearch] = useState("");

  useEffect(() => { loadData(); }, [page, search]);

  const loadData = async () => {
    setLoading(true);
    const res = await fetchIpaLessons({ page, size: 20, search: search || undefined });
    if (res.status === 200 && res.data) {
      setData(res.data.content || []);
      setTotalPages(res.data.totalPages || 0);
    } else {
      setData([]);
      alert(res.message || "Failed to load lessons");
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this lesson?")) return;
    const res = await deleteIpaLesson(id);
    if (res.status === 200 || res.status === 204) loadData();
    else alert(res.message);
  };

  const onFormSaved = () => { setShowForm(false); setEditing(null); loadData(); };

  return (
    <div className="admin-container">
      <div className="admin-header">
        <h2>IPA Lessons Management</h2>
        <button onClick={() => { setEditing(null); setShowForm(true); }}>+ Add Lesson</button>
      </div>

      {showForm && (
        <AdminIpaLessonForm lesson={editing} onSaved={onFormSaved} onCancel={() => setShowForm(false)} />
      )}

      <input
        type="text"
        placeholder="Search lessons..."
        value={search}
        onChange={(e) => { setPage(0); setSearch(e.target.value); }}
      />

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table className="announcement-table">
          <thead>
            <tr>
              <th>Title</th>
              <th>Difficulty</th>
              <th>Symbols</th>
              <th>Order</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr><td colSpan="5">No lessons found</td></tr>
            ) : (
              data.map((item) => (
                <tr key={item.id}>
                  <td>{item.title}</td>
                  <td>{item.difficulty}</td>
                  <td>{item.symbols?.length || 0} symbols</td>
                  <td>{item.sortOrder}</td>
                  <td>
                    <button onClick={() => { setEditing(item); setShowForm(true); }}>Edit</button>
                    <button className="delete-btn" onClick={() => handleDelete(item.id)}>Delete</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}

      <div style={{ marginTop: "20px" }}>
        <button disabled={page === 0} onClick={() => setPage(page - 1)}>Prev</button>
        <span style={{ margin: "0 10px" }}>Page {page + 1} / {totalPages || 1}</span>
        <button disabled={page + 1 >= totalPages} onClick={() => setPage(page + 1)}>Next</button>
      </div>
    </div>
  );
};

export default AdminIpaLessonPage;
